// extracted by mini-css-extract-plugin
export var hideEditor = "_i3-2";
export var infoIcon = "_i3-3";
export var label = "_i3-1";
export var labelContainer = "_i3-0";
export var readonlyText = "_i3-4";